export default "__VITE_ASSET__BlckKAkD__"